import MessageFormatOptionState from '../store/schema/MessageFormatOptionState';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import MailboxMessageConfigurationOptions from 'owa-service/lib/contract/MailboxMessageConfigurationOptions';
import MailFormat from 'owa-service/lib/contract/MailFormat';
import { setMailboxMessageConfiguration } from 'owa-options-core';
import FontFlags from 'owa-service/lib/contract/FontFlags';
import FontFlags2 from 'owa-service/lib/contract/FontFlags2';

export interface SaveMessageFormatOptionState {
    optionState: MessageFormatOptionState;
    userOptions: UserOptionsType;
}

export default select<SaveMessageFormatOptionState>({
    optionState: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})(
    action('saveMessageFormatOption')(async function saveMessageFormatOption(
        state?: SaveMessageFormatOptionState
    ) {
        let { optionState, userOptions } = state;

        let serviceObject: MailboxMessageConfigurationOptions = {};

        if (optionState.showBcc !== null) {
            userOptions.AlwaysShowBcc = optionState.showBcc;
            serviceObject.AlwaysShowBcc = optionState.showBcc;
        }

        if (optionState.showFrom !== null) {
            userOptions.AlwaysShowFrom = optionState.showFrom;
            serviceObject.AlwaysShowFrom = optionState.showFrom;
        }

        if (optionState.composeFormat !== null) {
            userOptions.ComposeMarkup = optionState.composeFormat;
            switch (optionState.composeFormat) {
                case 'Html':
                    serviceObject.DefaultFormat = MailFormat.Html;
                    break;
                case 'PlainText':
                    serviceObject.DefaultFormat = MailFormat.PlainText;
                    break;
            }
        }

        if (optionState.fontFamily !== null) {
            userOptions.ComposeFontName = optionState.fontFamily;
            serviceObject.DefaultFontName = optionState.fontFamily;
        }

        if (optionState.fontSize !== null) {
            userOptions.ComposeFontSize = optionState.fontSize;
            serviceObject.DefaultFontSize = optionState.fontSize;
        }

        if (
            optionState.isFontBold !== null ||
            optionState.isFontItalic !== null ||
            optionState.isFontUnderline !== null
        ) {
            userOptions.ComposeFontFlags = applyFontFlagIfNonNull(
                optionState.isFontBold,
                FontFlags.Bold,
                userOptions.ComposeFontFlags
            );
            userOptions.ComposeFontFlags = applyFontFlagIfNonNull(
                optionState.isFontItalic,
                FontFlags.Italic,
                userOptions.ComposeFontFlags
            );
            userOptions.ComposeFontFlags = applyFontFlagIfNonNull(
                optionState.isFontUnderline,
                FontFlags.Underline,
                userOptions.ComposeFontFlags
            );

            // For some reason, owa-service has two identical enums, FontFlags and FontFlags2.
            // Cast one to the other for typechecking
            serviceObject.DefaultFontFlags = <FontFlags2>(<number>userOptions.ComposeFontFlags);
        }

        if (optionState.fontColor !== null) {
            userOptions.ComposeFontColor = optionState.fontColor;
            serviceObject.DefaultFontColor = optionState.fontColor;
        }

        await setMailboxMessageConfiguration(serviceObject);
    })
);

function applyFontFlagIfNonNull(
    isFlagSet: boolean | null,
    flagToSet: FontFlags,
    collectedFlags: FontFlags
): FontFlags {
    if (isFlagSet === null) {
        return collectedFlags;
    } else if (isFlagSet) {
        return collectedFlags | flagToSet;
    } else {
        return collectedFlags ^ flagToSet;
    }
}
